import UserAvatar from "../UserAvatar";
import { getTrophyByKey } from "../../data/trophyCatalog";

const STROKE = 1.8;

function TrophyStarIcon({ size = 9 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="white" stroke="none" aria-hidden>
      <path d="M12 2l2.4 7.4H22l-6.2 4.5 2.4 7.4L12 17l-6.2 4.3 2.4-7.4L2 9.4h7.6z" />
    </svg>
  );
}

/** Pinned trophy badge overlay for avatars across profile pages. */
export default function AvatarWithTrophy({
  src,
  alt = "",
  name = "",
  className = "",
  imgClassName = "",
  imgStyle,
  size = "md",
  pinnedTrophy,
  ring = false,
  verified = false,
}) {
  const trophy = pinnedTrophy ? getTrophyByKey(pinnedTrophy) : null;
  const badgeSize = size === "lg" ? "lg" : size === "sm" ? "sm" : "md";
  const displayName = name || alt;

  return (
    <div className={`av-trophy-wrap av-trophy-wrap--${size} ${className}`}>
      <UserAvatar
        src={src}
        alt={alt}
        name={displayName}
        className={imgClassName}
        style={imgStyle}
      />
      {ring && <div className="av-trophy-ring" aria-hidden />}
      {verified && (
        <div className="av-trophy-verified" aria-label="Verified creator">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth={STROKE + 0.7} strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </div>
      )}
      {trophy && (
        <div
          className={`av-trophy-badge av-trophy-badge--${badgeSize}`}
          title={trophy.name}
          style={{ background: trophy.iconStroke || "var(--gold)" }}
        >
          <TrophyStarIcon size={badgeSize === "lg" ? 13 : badgeSize === "sm" ? 7 : 9} />
        </div>
      )}
    </div>
  );
}

export { TrophyStarIcon };
